<template>
  <div id="nav">
    <router-link to="/">Home</router-link> | 
    <router-link to="/ai-ml">AI ML</router-link> |
    <router-link to="/payment">Payment</router-link>
  </div>
  <div id="main">
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
